export default {
  TOP: 'top',
  CENTER: 'center',
};
